import styled from 'styled-components';
import { Snackbar } from '@mui/material';

const SnackbarWrapper = styled(Snackbar)``;

export { SnackbarWrapper };
